var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyseOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90625 2.5C4.92523 2.5 2.5 4.92523 2.5 7.90625C2.5 10.8873 4.92523 13.3125 7.90625 13.3125C10.8873 13.3125 13.3125 10.8873 13.3125 7.90625C13.3125 4.92523 10.8873 2.5 7.90625 2.5ZM7.90625 0C12.2727 0 15.8125 3.53975 15.8125 7.90625C15.8125 12.2727 12.2727 15.8125 7.90625 15.8125C3.53975 15.8125 0 12.2727 0 7.90625C0 3.53975 3.53975 0 7.90625 0Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5635 13.125L18.7505 18.75",
    stroke: "#272D55",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.59961C6 8.04732 5.55228 7.59961 5 7.59961C4.44772 7.59961 4 8.04732 4 8.59961V9.59961C4 10.1519 4.44772 10.5996 5 10.5996C5.55228 10.5996 6 10.1519 6 9.59961V8.59961Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.59961C5.5 8.32347 5.27614 8.09961 5 8.09961C4.72386 8.09961 4.5 8.32347 4.5 8.59961V9.59961C4.5 9.87575 4.72386 10.0996 5 10.0996C5.27614 10.0996 5.5 9.87575 5.5 9.59961V8.59961Z",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.59961C9 7.04732 8.55228 6.59961 8 6.59961C7.44772 6.59961 7 7.04732 7 7.59961V9.59961C7 10.1519 7.44772 10.5996 8 10.5996C8.55228 10.5996 9 10.1519 9 9.59961V7.59961Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.59961C8.5 7.32347 8.27614 7.09961 8 7.09961C7.72386 7.09961 7.5 7.32347 7.5 7.59961V9.59961C7.5 9.87575 7.72386 10.0996 8 10.0996C8.27614 10.0996 8.5 9.87575 8.5 9.59961V7.59961Z",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.59961C12 6.04732 11.5523 5.59961 11 5.59961C10.4477 5.59961 10 6.04732 10 6.59961V9.59961C10 10.1519 10.4477 10.5996 11 10.5996C11.5523 10.5996 12 10.1519 12 9.59961V6.59961Z",
    fill: "#272D55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.59961C11.5 6.32347 11.2761 6.09961 11 6.09961C10.7239 6.09961 10.5 6.32347 10.5 6.59961V9.59961C10.5 9.87575 10.7239 10.0996 11 10.0996C11.2761 10.0996 11.5 9.87575 11.5 9.59961V6.59961Z",
    stroke: "#272D55",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyseOperationIcon);
export default __webpack_public_path__ + "static/media/AnalyseOperationIcon.fa96f41ed749bee4bf64168b12ac19cc.svg";
export { ForwardRef as ReactComponent };